import {
  FDBodyText, FDHeadlineText,
} from '@facet-wealth/design';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';


export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDHeadlineText,
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDBodyText,
    _customProps: {
      size: 'lg',
    },
  }, overrideReadOnly);
